export default class Skill {
  name: string
  level: number
  years: number

  /**
   * The portfolio owner skill.
   * [name] the skill name. eg: PHP
   * [level] the skill level percentage. eg: 89
   * [years] of experience.
   */
  constructor(options: { name: string, level: number, years: number }) {
    this.level = options.level
    this.name = options.name
    this.years = options.years
  }
}
